// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    padding: theme.spacing(1),
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(1),
  },
  titleText: {
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  dialogContent: {
    padding: '10px 24px',
    marginTop: '12px',
  },
  checked: {
    '&.Mui-checked': {
      color: '#01A1DD',
    },
  },
  nearmapDialogBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '500px',
  },
  listItem: {
    padding: '0px 8px',
  },
  listItemText: {
    marginTop: '0px',
    marginBottom: '0px',
  },
  warningIcon: {
    color: '#FAA738',
    marginLeft: '16px',
    marginTop: '12px',
  },
});

export default styles;
